
export default {
  name: 'Terms',
}
